import React, { useState } from "react";
import { useMediaQuery, createTheme } from "@material-ui/core";
import { Button, Grid, Typography, List, ListItem, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "react-responsive-modal/styles.css";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { claimReward } from "../../service/myloyalty_services";
import { getFullPath } from "../../config/retailerConfig";

export function RewardDetailsModal(props) {
  const {
    retailer,
    reward,
    rewards,
    balance,
    blockTheme,
    isLogin,
    onOrderSuccess,
    onClose,
  } = props;

  const [currentStep, setCurrentStep] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [error, setError] = useState(null);

  const theme = createTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isIpad = useMediaQuery(theme.breakpoints.down("md"));

  const userData = JSON.parse(localStorage.getItem("userData"));

  const getRewardSizes = () => {
    if (reward.offer.tags && reward.offer.tags.length > 0) {
      const rewardGroup = rewards.filter(
        (r) => r.targetThreshold === reward.targetThreshold
      );

      const listOfRewards = rewardGroup[0].rewards.filter(
        (r) => r.offer.tags[0] == reward.offer.tags[0]
      );
      let rewardSizes = [];
      for (let r of listOfRewards) {
        rewardSizes.push({
          id: r.offer.id,
          size: r.offer.terms,
          isAvilable: r.offer.status === "available" ? true : false,
        });
      }

      return rewardSizes;
    }

    return [];
  };

  const cliamReward = async () => {
    if (selectedSize || reward.offer.tags.length === 0) {
      const response = await claimReward(
        retailer,
        reward.offer.tags.length === 0 ? reward.offer.id : selectedSize.id,
        "discount"
      );
      if (!response.error) {
        setOrderNumber(response?.id);
        setCurrentStep(currentStep + 1);
      } else {
        setError(
          error?.response?.data
            ? error?.response?.data?.reason
            : "Unable to claim the reward, Please contact support!!"
        );
      }
    }
  };

  return (
    <div
      className="rewardDetailsModal"
      style={{
        width: isMobile ? "100%" : isIpad ? "600px" : "760px",
        padding: isMobile ? "0" : "24px",
      }}
    >
      {/* Modal Header */}
      <Typography
        sx={{
          fontSize: isMobile ? "18px" : "28px",
          lineHeight: "30.8px",
          fontWeight: "700",
        }}
      >
        {currentStep === 1
          ? "Reward details"
          : currentStep === 2
          ? "Review order"
          : "Order confirmation"}
      </Typography>

      {!isMobile && (
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "switzer",
            lineHeight: "24px",
            fontWeight: "400",
            marginTop: "4px",
          }}
        >
          Step {currentStep} of 3
        </Typography>
      )}

      {/* Step 1 */}
      {currentStep === 1 && (
        <Box
          sx={{
            height: isMobile ? "100%" : "420px",
            marginTop: "24px",
          }}
          className="rewardDetailsStep"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <img
              style={{
                width: isMobile ? "100%" : "340px",
                borderRadius: "16px",
              }}
              src={
                reward.offer.enhancedImageUrl
                  ? reward.offer.enhancedImageUrl
                  : reward.offer.imageUrl
              }
            />

            <Box
              className="rewardDetails"
              sx={{
                padding: isMobile ? "0" : "0 20px",
                marginTop: isMobile ? "24px" : "0",
              }}
            >
              <Typography
                sx={{
                  fontSize: isMobile ? "28px" : isIpad ? "32px" : "42px",
                  lineHeight: isMobile ? "30.8px" : "46.2px",
                  fontFamily: "switzer",
                  fontWeight: "700",
                }}
              >
                {reward.offer.description}
              </Typography>
              <Typography
                sx={{ fontFamily: "switzer", fontSize: "18px", opacity: ".8" }}
              >
                {reward.offer.value} Points
              </Typography>

              {getRewardSizes().length > 0 && (
                <Typography
                  sx={{
                    fontSize: "600",
                    fontSize: "18px",
                    fontFamily: "switzer",
                    fontWeight: "700",
                    marginTop: isMobile ? "16px" : "24px",
                    marginBottom: "8px",
                  }}
                >
                  Available sizes
                </Typography>
              )}

              {getRewardSizes().map((r, idx) => (
                <div
                  className="btn"
                  style={{
                    borderRadius: "8px",
                    border: "1px solid #132949",
                    background: !r.isAvilable
                      ? "#B6BAC3"
                      : selectedSize?.size === r.size
                      ? blockTheme
                        ? blockTheme.button_background_color
                        : "#132949"
                      : "#fff",
                    color:
                      selectedSize?.size === r.size
                        ? blockTheme
                          ? blockTheme.text_color
                          : "#fff"
                        : "#132949",
                    padding: "16px",
                    fontFamily: "switzer",
                    fontSize: "18px",
                    fontWeight: "700",
                    marginRight: "8px",
                    minWidth: "52px",
                    opacity: r.isAvilable ? 1 : 0.6,
                    cursor: r.isAvilable ? "pointer" : "not-allowed",
                    textDecoration: r.isAvilable ? "none" : "line-through",
                  }}
                  onClick={() => {
                    if (r.isAvilable) {
                      setSelectedSize(r);
                    }
                  }}
                >
                  {r.size}
                </div>
              ))}
            </Box>
          </Box>

          <Typography
            sx={{
              margin: "24px 0",
              fontSize: isMobile ? "16px" : "18px",
              fontWeight: "400",
              lineHeight: "27px",
              fontFamily: "switzer",
            }}
          >
            {reward.offer.description}
          </Typography>
        </Box>
      )}

      {/* Step 2 */}
      {currentStep === 2 && (
        <Box
          sx={{
            marginTop: isMobile ? "0" : "24px",
            height: isMobile ? "100%" : "420px",
          }}
          className="reviewOrderStep"
        >
          <Grid
            item
            sx={{
              display: "grid",
              gridTemplateColumns: isMobile
                ? "repeat(1, 1fr)"
                : "repeat(2, 1fr)",
              gridAutoFlow: isMobile ? "dense" : "row",
            }}
          >
            <Grid item>
              <Typography
                sx={{
                  fontSize: isMobile ? "16px" : "18px",
                  fontFamily: "switzer",
                  lineHeight: "17.6px",
                  fontWeight: "700",
                  marginTop: isMobile ? "24px" : "4px",
                  marginBottom: isMobile ? "8px" : "16px",
                }}
              >
                Product details
              </Typography>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  background: isMobile ? "#EDEEF1" : "transparent",
                  borderRadius: isMobile ? "16px" : "0",
                  padding: isMobile ? "16px" : "0",
                  alignItems: isMobile ? "center" : "flex-start",
                }}
              >
                <img
                  style={{ borderRadius: "16px" }}
                  src={reward.offer.imageUrl}
                />
                <List
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    listStyle: "none",
                    paddingLeft: "10px",

                    "& .MuiListItem-root": {
                      padding: "2px 0",
                      fontFamily: "switzer",
                      fontSize: isMobile ? "16px" : "18px",
                    },
                  }}
                >
                  <ListItem sx={{ fontWeight: "400", lineHeight: "19.8px" }}>
                    {reward.offer.description}
                  </ListItem>
                  <ListItem sx={{ opacity: ".8", lineHeight: "24px" }}>
                    {reward.offer.value} Points
                  </ListItem>
                  {reward.offer.tags.length > 0 && (
                    <ListItem sx={{ opacity: ".8" }}>
                      Size: {selectedSize?.size}
                    </ListItem>
                  )}
                </List>
              </div>
            </Grid>

            <Grid item>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: isMobile ? "16px" : "18px",
                  width: "100%",
                  fontWeight: "700",
                  lineHeight: "17.6px",
                  fontFamily: "switzer",
                  marginTop: isMobile ? "24px" : "0",
                  marginBottom: isMobile ? "8px" : "16px",
                }}
              >
                <span> {isMobile ? "Shipping details" : "Ship to"}</span>
                {/* {!isMobile && ( */}
                <span
                  onClick={() => navigate(getFullPath("account"))}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  Edit <ArrowOutwardIcon />
                </span>
                {/* )} */}
              </Typography>

              <List
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  listStyle: "none",
                  padding: "0",

                  "& .MuiListItem-root": {
                    padding: "2px 0",
                    fontFamily: "switzer",
                    fontSize: "18px",
                    fontWeight: "400",
                  },
                }}
              >
                <ListItem sx={{ textTransform: "capitalize" }}>
                  {userData.firstName}&nbsp; {userData.lastName}
                </ListItem>
                <ListItem>
                  {userData.address1}, {userData.address2}
                </ListItem>
                <ListItem>{userData.phone}</ListItem>
                <ListItem>{userData.email}</ListItem>
              </List>
            </Grid>
          </Grid>

          <div
            style={{
              marginTop: isMobile ? "0" : "6.2rem",
              marginBottom: isMobile ? "24px" : "0",
              width: "100%",
            }}
          >
            {isMobile && (
              <Typography
                variant="h6"
                sx={{
                  fontSize: "16px",
                  fontFamily: "switzer",
                  lineHeight: "17.6px",
                  fontWeight: "700",
                  marginTop: "24px",
                  marginBottom: "6px",
                }}
              >
                Point Balance
              </Typography>
            )}

            <label style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "switzer",
                  lineHeight: "19.8px",
                  fontWeight: "400",
                  marginTop: "4px",
                }}
              >
                Points Balance
              </Typography>
              <Typography>{balance}</Typography>
            </label>

            <label style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "switzer",
                  fontWeight: "400",
                  marginTop: "4px",
                }}
              >
                {reward.offer.description}
              </Typography>
              <Typography>{reward.offer.value}</Typography>
            </label>

            <label
              style={{
                display: "flex",
                justifyContent: "space-between",
                borderTop: "1px solid #B6BAC3",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "switzer",
                  fontWeight: "700",
                  marginTop: "4px",
                }}
              >
                Balance after purchase
              </Typography>
              <Typography
                sx={{
                  fontWeight: "700",
                }}
              >
                {balance - reward.offer.value}
              </Typography>
            </label>
          </div>

          {error && (
            <Typography
              sx={{
                display: "flex",
                justifyContent: "center",
                margin: "10px",
                padding: "8px",
                color: "red",
                background: "#ffe1e1",
                border: "1px solid red",
                borderRadius: "12px",
                fontSize: "16px",
              }}
            >
              {error}
            </Typography>
          )}
        </Box>
      )}

      {/* Step 3 */}
      {currentStep === 3 && (
        <Box
          sx={{
            height: isMobile ? "100%" : "420px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: "18px",
              fontFamily: "switzer",
              lineHeight: "23.8px",
              fontWeight: "700",
              marginTop: "24px",
            }}
          >
            Woohoo! Your Order’s In!
          </Typography>

          <Typography
            sx={{
              fontSize: "18px",
              fontFamily: "switzer",
              lineHeight: "19.8px",
              margin: "10px 0",
              fontWeight: "400",
            }}
          >
            Thanks Brain! Your order has been successfully place and we are
            getting everything is ready in 2 -3 business days.
          </Typography>

          <Typography
            sx={{
              fontSize: "18px",
              fontFamily: "switzer",
              lineHeight: "19.8px",
              marginTop: "30px",
              fontWeight: "700",
              opacity: ".8",
            }}
          >
            Order Number: {orderNumber}
          </Typography>
        </Box>
      )}

      {/* Modal Footer */}
      <div
        className="footer"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {(isMobile && currentStep === 2) ||
          (!isMobile && currentStep !== 3 && (
            <Button
              onClick={() => {
                if (isLogin) {
                  if (currentStep === 1) {
                    onClose();
                  } else {
                    setError(null);
                    setCurrentStep(currentStep - 1);
                  }
                } else {
                  navigate(getFullPath("login"));
                }
              }}
              sx={{
                width: "100%",
                padding: isMobile ? "10px" : "16px",
                border: `1px solid ${
                  blockTheme ? blockTheme.button_background_color : "#132949"
                }`,
                borderRadius: "240px",
                fontSize: "18px",
                fontWeight: "700",
                margin: "0 10px",
                color: blockTheme
                  ? blockTheme.button_background_color
                  : "#132949",
                background: "#fff",

                "&:focus": {
                  outline: "none",
                },
              }}
              loading={true}
            >
              {" "}
              {isLogin ? (currentStep === 1 ? "Cancel" : "Back") : "Login"}
            </Button>
          ))}

        {isLogin && (
          <Button
            loading={true}
            sx={{
              width: "100%",
              padding: isMobile ? "10px" : "16px",
              border: "1px solid #132949",
              borderRadius: "240px",
              fontFamily: "switzer",
              fontSize: "18px",
              fontWeight: "700",
              margin: isMobile ? "0" : "0 10px",
              color: blockTheme ? blockTheme.text_color : "#fff",
              background: blockTheme
                ? blockTheme.button_background_color
                : "#132949",

              "&:hover": {
                background: blockTheme
                  ? blockTheme.button_background_color
                  : "#132949",
                opacity: ".8",
              },

              "& .Mui-disabled": {
                color: blockTheme ? blockTheme.text_color : "#fff !important",
                background: blockTheme
                  ? blockTheme.button_background_color
                  : "#132949",
                opacity: ".6",
              },
            }}
            onClick={() => {
              if (currentStep === 1) {
                if (reward.offer.tags.length === 0 || selectedSize) {
                  return setCurrentStep(currentStep + 1);
                }

                return false;
              }

              if (currentStep === 2) {
                return cliamReward();
              }

              onOrderSuccess();
            }}
          >
            {currentStep === 1
              ? "Claim reward"
              : currentStep === 2
              ? "Confirm order"
              : "Done"}
          </Button>
        )}
      </div>
    </div>
  );
}
export default RewardDetailsModal;
